import { isStandalone } from './src/styles/media'
import { CARD_MARKET, TCG_PLAYER } from './src/data/priceSources'
import { EUR, USD } from './src/data/currencies'

export const siteHasDeckStatus = false

export const enableServiceWorker = true

export const titleSuffix = !isStandalone() ? ' – cardcluster' : ''

export const domains = {
	de: 'cardcluster.de',
	en: 'cardcluster.com',
	fr: 'cardcluster.fr',
	it: 'cardcluster.it',
	es: 'cardcluster.es',
	pt: 'cardcluster.pt'
}

export const htmlHeadMapping = {
	'en-US': 'en',
	'en-GB': 'en',
	'de-DE': 'de',
	'fr-FR': 'fr',
	'it-IT': 'it',
	'es-ES': 'es',
	'pt-PT': 'pt'
}

export const languageDefaults = {
	en: 'en-GB',
	de: 'de-DE',
	fr: 'fr-FR',
	it: 'it-IT',
	es: 'es-ES',
	pt: 'pt-PT'
}

export const priceSourceDefaults = {
	de: CARD_MARKET,
	en: TCG_PLAYER,
	fr: CARD_MARKET,
	it: CARD_MARKET,
	es: CARD_MARKET,
	pt: CARD_MARKET
}

export const currencyDefaults = {
	de: EUR,
	en: USD,
	fr: EUR,
	it: EUR,
	es: EUR,
	pt: EUR
}

export const translationsMapping = {
	'en-US': 'en',
	'en-GB': 'en',
	'de-DE': 'de',
	'fr-FR': 'fr',
	'it-IT': 'it',
	'es-ES': 'es',
	'pt-PT': 'pt'
}

export const cardNameLanguageMapping = {
	'en-US': 'en',
	'en-GB': 'en',
	'de-DE': 'de',
	'fr-FR': 'fr',
	'it-IT': 'it',
	'es-ES': 'es',
	'pt-PT': 'pt'
}

export const discordLink = 'https://discord.gg/Ymn6eWMA2S'
